module.exports = __webpack_public_path__ + "h5/img/summer-navc11.8ae2a3fe.png";